import React from 'react'
import { Container, Line, Title } from './styles'

interface TitleLineProps {
  title: string
}

export const TitleLine = ({ title }: TitleLineProps) => {
  return (
    <Container>
      <Title>{title}</Title>
      <Line />
    </Container>
  )
}
